import React from 'react';
import './App.css';
import Hero from './components/Hero';
import Security from './components/Security';
import Features from './components/Features';
import About from './components/About';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';
import Header from './components/Header';

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <Security />
      <Features />
      <About />
      <ContactForm />
      <Footer />

      <div className="coffee-callout" data-event="coffee_widget_open">
        <span className="coffee-text">¡Apóyanos aquí!</span>
        <span className="coffee-arrow">➔</span>
      </div>
    </div>
  );
}

export default App;